import { __extends } from "tslib";
import * as React from "react";
import ContentView from './ContentView';
import { Text, View } from 'react-native';
var ContentShellView = /** @class */ (function (_super) {
    __extends(ContentShellView, _super);
    /* CONSTRUCTOR */
    function ContentShellView(props) {
        return _super.call(this, props) || this;
    }
    ContentShellView.prototype.getSwitch = function () {
        if (this._binding != null) {
            return this._binding.getSwitch();
        }
        else {
            return (React.createElement(View, { style: { flex: 1, justifyContent: 'center', alignContent: 'center' } },
                React.createElement(Text, null, "No switch")));
        }
    };
    return ContentShellView;
}(ContentView));
export default ContentShellView;
